module.exports = __webpack_public_path__ + "img/closeleft.d8397425.svg";